import styled from 'styled-components';

import { mediaConfined, mediaWide, mediaXWide } from '@xing-com/layout-tokens';
import {
  spaceXS,
  spaceXXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  space5XL,
  space6XL,
} from '@xing-com/tokens';

export const SIZES = {
  spaceNone: '0',
  spaceXS,
  spaceXXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  space5XL,
  space6XL,
} as const;

export type Size = keyof typeof SIZES;

interface SpacerProps {
  $size: Size;
  $sizeConfined?: Size;
  $sizeWide?: Size;
  $sizeXWide?: Size;
  $axis?: 'vertical' | 'horizontal';
}

export const Spacer = styled.span<SpacerProps>`
  display: block;
  min-width: ${({ $axis, $size }) => getWidth({ $axis, $size })};
  min-height: ${({ $axis, $size }) => getHeight({ $axis, $size })};

  @media ${mediaConfined} {
    min-width: ${({ $axis, $sizeConfined }) =>
      getWidth({ $axis, $size: $sizeConfined })};

    min-height: ${({ $axis, $sizeConfined }) =>
      getHeight({ $axis, $size: $sizeConfined })};
  }

  @media ${mediaWide} {
    min-width: ${({ $axis, $sizeWide }) =>
      getWidth({ $axis, $size: $sizeWide })};

    min-height: ${({ $axis, $sizeWide }) =>
      getHeight({ $axis, $size: $sizeWide })};
  }

  @media ${mediaXWide} {
    min-width: ${({ $axis, $sizeXWide }) =>
      getWidth({ $axis, $size: $sizeXWide })};
    min-height: ${({ $axis, $sizeXWide }) =>
      getHeight({ $axis, $size: $sizeXWide })};
  }
`;

type GetWidthHeight = Partial<Pick<SpacerProps, '$axis' | '$size'>>;

export function getWidth({
  $axis = 'vertical',
  $size,
}: GetWidthHeight): string | undefined {
  if (!$size) return;

  return $axis === 'vertical'
    ? $size === 'spaceNone'
      ? SIZES[$size]
      : '1px'
    : SIZES[$size];
}

export function getHeight({
  $axis = 'vertical',
  $size,
}: GetWidthHeight): string | undefined {
  if (!$size) return;

  return $axis === 'horizontal'
    ? $size === 'spaceNone'
      ? SIZES[$size]
      : '1px'
    : SIZES[$size];
}
